var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header bg-primary w-100 h-100 p-3"},[_vm._v("JEPARTS Admin dashboard")])}
var staticRenderFns = []

export { render, staticRenderFns }